import strings from '../../../Localization/Localization';

import {
  getTransatelOptions
} from '../../../API/TransatelMVNO'

let transatelPreviousThreshold = {
  fieldKey: "transatelPreviousThreshold",
  label: strings.form.transatelDataRecharge.transatelPreviousThreshold.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  filterOptions: (option) => option["transatel_group"] === "data_threshold",
  loader: {
    id: "transatel_options",
    loader: getTransatelOptions,
    loaderRequire: () => true,
    loaderArguments: () => [],
    dataTransformation: (data) => data.result.data
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

export const form = {
  formKey: "transatelDataRechargeSearch",
  fields: [
    transatelPreviousThreshold
  ]
}
